import { gql } from "@apollo/client"

export const TOURNAMENT_FINISH = gql`
  mutation TournamentFinish($TournamentFinishInput: TournamentFinishInput!) {
    TournamentFinish(input: $TournamentFinishInput) {
      status {
        success
        name
        detail
      }
      Tournament {
        id
        name
        urlView
        isPresential
      }
    }
  }
`
